import { Grid } from '@mui/material';
import { SubjectLayout } from 'layouts/SubjectLayout';
import { HomeShow } from './HomeShow';
import { HomeList } from './HomeList';
import { useSetupAppHome } from './useSetupAppHome';

export const Bold = ({ children }) => (
  <span
    style={{
      fontWeight: 'bold',
      padding: '0 4px',
    }}>
    {children}
  </span>
);

export const SetupAppHome = () => {
  const { savingHomeApp, saveAppHome, saveAppHomeList, saveAppHomeShow } =
    useSetupAppHome();

  return (
    <SubjectLayout.Root id="main-application" limitWidth>
      <SubjectLayout.Title>Home do App</SubjectLayout.Title>

      <SubjectLayout.OptionsButton
        loading={savingHomeApp}
        disabled={savingHomeApp}
        label="Publicar no App"
        options={[
          {
            label: (
              <>
                Atualizar
                <Bold>Home show</Bold>
              </>
            ),
            onClick: saveAppHomeShow,
          },
          {
            label: (
              <>
                Atualizar
                <Bold>Home list</Bold>
              </>
            ),
            onClick: saveAppHomeList,
          },
          {
            label: 'Atualizar Home show e Home list',
            onClick: saveAppHome,
          },
        ]}
      />
      <SubjectLayout.InnerContainer columnSpacing={4}>
        <Grid item xs={6}>
          <HomeShow />
        </Grid>
        <Grid item xs={6}>
          <HomeList />
        </Grid>
      </SubjectLayout.InnerContainer>
    </SubjectLayout.Root>
  );
};
